import * as React from "react";
import { MenuItem } from "react-ui";

interface DropdownMenuItemProps {
    children: React.ReactNode;
}

export function DropdownMenuItem(props: DropdownMenuItemProps): JSX.Element {
    return <MenuItem>{props.children}</MenuItem>;
}

// @ts-ignore
DropdownMenuItem.__MENU_ITEM__ = true;

// @ts-ignore эта пропертя заставляет react-ui склонировать всех детей ниже
//  и передать им в props свойства onMouseEnter/onMouseLeave что позволяет управлять ховером
DropdownMenuItem.__KONTUR_REACT_UI__ = "MenuItem";
